import React from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import {
  GoogleTagManagerHead,
  GoogleTagManagerBody,
} from 'components/business/shared/GoogleTagManager'
import HeaderContainer from 'containers/business/HeaderContainer'
import Footer from 'components/business/shared/Footer'
import Path from 'routes/path'
// TODO: scss を読み込めないのでサービスに font を追加して読み込んでいる
// import 'frontend_component/dist/assets/stylesheets/fonts.scss'
import GlobalStyle from 'styles'

export default function BusinessLayout(props) {
  const { children, config } = props
  const title = props.title
    ? `${props.title} - ${i18n.t('server.business.shared.default_title')}`
    : i18n.t('server.business.shared.default_title')
  const description = i18n.t(
    props.description || 'server.business.shared.default_description',
  )
  const bodyClassNames = ['site-business']
  if (props.bodyClassName) bodyClassNames.push(props.bodyClassName)

  function renderAll(element) {
    return (
      <html>
        <head>
          <script type="text/javascript" src="https://js.stripe.com/v2/" />
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"
          />
          <title>{title}</title>
          <meta name="description" content={description} />
          <link
            rel="stylesheet"
            href={manifest['business/main.css']}
            media="screen"
          />
          <link
            href="https://use.fontawesome.com/releases/v5.0.10/css/all.css"
            rel="stylesheet"
          />
          <link rel="shortcut icon" href={imagePath('business/favicon.ico')} />
          <link rel="dns-prefetch" href="//business.spacemarket.com" />
          <GoogleTagManagerHead />
          <script
            src="https://browser.sentry-cdn.com/4.5.4/bundle.min.js"
            crossOrigin="anonymous"
          />
        </head>
        <body className={bodyClassNames.join(' ')}>
          <div id="js-root">{renderRoot()}</div>
          <GoogleTagManagerBody />
          <GlobalStyle />
        </body>
      </html>
    )
  }

  function renderRoot() {
    const { data, match, phone } = props
    const company = data.company
    return (
      <div>
        <HeaderContainer {...props} />
        <div className="site-business__main">{children}</div>
        <Footer />
      </div>
    )
  }
  return config.SSR ? renderAll() : renderRoot()
}
